<template>
  <v-app>
    <nav-drawer v-if="$route.name !== 'login' && currentUser" />
    <toolbar v-if="$route.name !== 'login' && currentUser" />

    <v-content>
      <v-container fluid fill-height pa-6>
        <v-layout>
          <router-view
            v-if="currentLocation || !currentUser || !requiresCurrentLocation"
            :key="routeKey"
          />
          <div v-else class="please-select">
            <h1>Please select a location</h1>
          </div>
        </v-layout>
      </v-container>
    </v-content>

    <v-snackbar v-model="snackbarEnabled" :color="snackbarContent.color">
      {{ snackbarContent.text }}
      <v-btn text class="font-weight-bold" @click="snackbarEnabled = false">
        Close
      </v-btn>
    </v-snackbar>
  </v-app>
</template>

<script>
import Toolbar from '@/components/Toolbar';
import NavDrawer from '@/components/NavDrawer';

export default {
  name: 'App',
  components: {
    Toolbar,
    NavDrawer
  },
  computed: {
    currentLocation() {
      return this.$store.state.currentLocation;
    },
    currentUser() {
      return this.$store.state.currentUser;
    },
    requiresCurrentLocation() {
      return !!this.$route.meta.requiresCurrentLocation;
    },
    routeKey() {
      if (this.currentLocation) {
        return this.currentLocation.id;
      } else {
        return this.$route.name;
      }
    },
    snackbarContent() {
      return this.$store.state.snackbar.content;
    },
    snackbarEnabled: {
      get() {
        return this.$store.state.snackbar.enabled;
      },
      set(value) {
        this.$store.commit('snackbarEnabled', value);
      }
    }
  }
};
</script>

<style lang="scss">
body {
  min-width: 768px;
}
</style>
